import WeightCounter from 'src/internal/platformMetrics/aggregators/WeightCounter';

export const safeParams = ['request', 'miss'] as const;

type SafeParams = (typeof safeParams)[number];

export const translationCountForMessageLength = new WeightCounter<SafeParams>(
  'i18n_translation_format_message_sml_total',
);
